export const routes = (parentName) => {
  return [
    {
      path: "my-classes",
      component: () => import("./Index.vue"),
      children: [
        {
          path: "",
          name: `${parentName}-My-Classes`,
          component: () => import("./List.vue"),
          props: (route) => ({
            step: route.query.step,
          }),
        },
        {
          path: "active",
          name: `${parentName}-My-Classes-Active`,
          component: () => import("./ClassProgress.vue"),
        },
        {
          path: "not-active",
          name: `${parentName}-My-Classes-Not-Active`,
          component: () => import("./ClassEnded.vue"),
        },
      ],
    },
  ];
};
